export enum HrEvents {
  DepartmentCreated = 'hr.department.Created'
}
